<nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!lightGridForm"></nz-skeleton>
<ng-container *ngIf="lightGridForm">
  <ng-container *ngIf="disablePopupMode">
    <ng-container *ngTemplateOutlet="dynamicForm; context: { $implicit: metaDataConfig.heading }">
    </ng-container>
    <button nz-button [disabled]="!formOutput" (click)="addDataToGrid(formOutput)" nzType="primary">Add</button>
    <nz-divider></nz-divider>
  </ng-container>

  <ng-container *ngIf="!disablePopupMode">
    <div class="heading-tab">
      <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> {{metaDataConfig.heading}}</h3>
      <div>
        <button *ngIf="metaDataConfig.enableAddRemoveRows" [disabled]="metaDataConfig.disabled" nz-button
          nzType="primary" (click)="openPopupToAddNewData()">
          Add
        </button>
      </div>
    </div>
  </ng-container>

  <form [formGroup]="lightGridForm">
    <nz-table *ngIf="refreshGridToggle" #editRowTable nzBordered [nzData]="listOfRows | filterSortGridData : filterOrSort: filterKey : searchValue: sortName : sortValue" 
      [nzShowPagination]="metaDataConfig.allowPagination" [nzPaginationPosition]="metaDataConfig.paginationPosition" [nzShowSizeChanger]="metaDataConfig.showRecordPerPageOption">
      <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
        <tr>
          <th nzWidth="40px">Sr</th>
          <ng-container *ngFor="let column of metaDataConfig.columns; let i=index">
            <!-- <th *ngIf="column.columnVisibility" [nzWidth]="column.columnWidth">
                {{column.fieldName}} <ng-container *ngTemplateOutlet="spellChecker; context: {phrase: column.fieldName}">
                </ng-container>
              </th> -->

            <ng-container *ngIf="column.columnVisibility">
              <th *ngIf="column.allowSort && column.allowFilter; else showHeaderWithSortOnly" nzCustomFilter nzShowSort
                [nzColumnKey]="column.fieldKey" [nzWidth]="column.columnWidth">
                {{column.fieldName}} <ng-container
                  *ngTemplateOutlet="spellChecker; context: {phrase: column.fieldName}"></ng-container>
                <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu" (nzVisibleChange)="filterMenuVisibilityChanged($event, column.fieldKey)">
                  <i nz-icon nzType="search" (click)="getConfigKey(column.fieldKey)"></i>
                </nz-filter-trigger>
              </th>
              <ng-template #showHeaderWithSortOnly>
                <th *ngIf="column.allowSort; else showSearchFilterOnly" nzShowSort [nzColumnKey]="column.fieldKey"
                  [nzWidth]="column.columnWidth">
                  {{column.fieldName}} <ng-container
                    *ngTemplateOutlet="spellChecker; context: {phrase: column.fieldName}"></ng-container>
                </th>
              </ng-template>
              <ng-template #showSearchFilterOnly>
                <th *ngIf="column.allowFilter; else showOnlyTableHeader" nzCustomFilter [nzColumnKey]="column.fieldKey"
                  [nzWidth]="column.columnWidth">
                  {{column.fieldName}} <ng-container
                    *ngTemplateOutlet="spellChecker; context: {phrase: column.fieldName}"></ng-container>
                  <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu" (nzVisibleChange)="filterMenuVisibilityChanged($event, column.fieldKey)">
                    <i nz-icon nzType="search" (click)="getConfigKey(column.fieldKey)"></i>
                  </nz-filter-trigger>
                </th>
              </ng-template>
              <ng-template #showOnlyTableHeader>
                <th *ngIf="!column.selectAll; else selectAllCheckboxTpl" [nzWidth]="column.columnWidth">{{column.fieldName}} <ng-container
                    *ngTemplateOutlet="spellChecker; context: {phrase: column.fieldName}"></ng-container></th>
              <ng-template #selectAllCheckboxTpl>
                <th [nzWidth]="column.columnWidth">
                  <label nz-checkbox (change)="selectAllCheckbox($event, column.fieldKey)"></label>
                </th>
              </ng-template>
              </ng-template>
            </ng-container>
          
          </ng-container>

          <th style="width: 120px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of editRowTable.data; let rowIndex = index">
          <tr [formGroup]="row">
            <td data-dd="Number" class="text-a-left" nzWidth="40px">
              {{ rowIndex + 1 }}
            </td>
            <ng-container *ngFor="let columnMetaData of metaDataConfig.columns; let columnIndex = index">
              <td #td *ngIf="columnMetaData.columnVisibility" [ngSwitch]="columnMetaData.fieldType"
                [class.inputs-are-disabled]="columnMetaData.disabled" [class.editable-row]="!columnMetaData.disabled">
                <!-- <ng-container *ngSwitchCase="'RADIO'">
                    <span [ngClass]="row.get(columnMetaData.fieldKey).value ? 'ant-radio ant-radio-checked': 'ant-radio'">
                      <input type="radio" [attr.name]="columnMetaData.fieldKey" [formControlName]="columnMetaData.fieldKey" class="ant-radio-input" (change)="deselectOtherRows($event, row, rowIndex, columnMetaData.fieldKey)">
                      <span class="ant-radio-inner"></span>
                    </span>
                </ng-container> -->
                <ng-container *ngIf="columnMetaData.fieldType != 'RADIO'">
                <ng-container *ngIf="!metaDataConfig.readOnly && (currentRow === rowIndex && currentFieldKey === columnMetaData.fieldKey)">
                  <!-- <input style="width: auto;" type="text" nz-input [(ngModel)]="columnMetaData.fieldName" /> -->

                  <ng-container *ngSwitchCase="'COMBO'">
                    <nz-select nzShowSearch nzAllowClear
                      [nzMode]="columnMetaData.comboMode? columnMetaData.comboMode : 'default'"
                      [id]="columnMetaData.fieldKey" [formControlName]="columnMetaData.fieldKey"
                      [nzDisabled]="columnMetaData.disabled" style="width: 100%">
                      <ng-container *ngIf="lookupValueListMap[columnMetaData.fieldKey + '-' + rowIndex]">
                        <nz-option
                          *ngFor="let item of lookupValueListMap[columnMetaData.fieldKey + '-' + rowIndex]; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-container>
                      <ng-container *ngIf="!lookupValueListMap[columnMetaData.fieldKey + '-' + rowIndex]">
                        <nz-option
                          *ngFor="let item of ((lookup$[columnMetaData.lookupCd] | async) || lookupData[columnMetaData.lookupCd]) as LookupList; trackBy:item?.lookupKey"
                          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      </ng-container>
                    </nz-select>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DATE'">
                    <nz-date-picker [id]="columnMetaData.fieldKey"
                      [formControlName]="columnMetaData.fieldKey" [nzDisabled]="columnMetaData.disabled"
                      [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                    </nz-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="'INPUT'">
                    <input nz-input [formControlName]="columnMetaData.fieldKey" [readonly]="columnMetaData.disabled" [maxlength]="columnMetaData.length"/>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CURRENCYINPUT'">
                    <input currencyMask type="text" [options]="currencyOptions" nz-input
                      [formControlName]="columnMetaData.fieldKey" [readonly]="columnMetaData.disabled" />
                  </ng-container>
                  <ng-container *ngSwitchCase="'TEXTAREA'">
                    <textarea rows="1" [maxlength]="columnMetaData.maxlength" nz-input
                      [formControlName]="columnMetaData.fieldKey"></textarea>
                    <p style="font-size: xx-small;">
                      {{parentFormItem.value[columnMetaData.fieldKey]? parentFormItem.value[columnMetaData.fieldKey].length: 0}}{{columnMetaData.maxlength? '/' + columnMetaData.maxlength : null}}
                      Characters</p>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CHECKBOX'">
                    <label nz-checkbox [formControlName]="columnMetaData.fieldKey" (change)="deselectOtherRows($event, row, rowIndex, columnMetaData.fieldKey)">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="'TIME'">
                    <nz-time-picker [id]="columnMetaData.fieldKey" [formControlName]="columnMetaData.fieldKey"
                      [nzDisabled]="columnMetaData.disabled" style="width:100%" [nzFormat]="'HH:mm'">
                    </nz-time-picker>
                  </ng-container>

                </ng-container>
                <ng-container *ngIf="metaDataConfig.readOnly || !(currentRow === rowIndex && currentFieldKey === columnMetaData.fieldKey)">
                  <div class="editable-cell">
                    <div class="editable-cell-value-wrap"
                      (click)="startEdit(rowIndex, columnMetaData.fieldKey, $event)">
                      <span [ngSwitch]="columnMetaData.fieldType">
                        <ng-container *ngSwitchCase="'DATE'">
                          {{row.value[columnMetaData.fieldKey]? (row.value[columnMetaData.fieldKey] | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '-'}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'TIME'">
                          {{row.value[columnMetaData.fieldKey]? (row.value[columnMetaData.fieldKey] | date : appMetadataHandler.GLOBAL_TIME_FORMAT_ANGULAR) : '-'}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'CHECKBOX'">
                          <label nz-checkbox nzDisabled [formControlName]="columnMetaData.fieldKey">
                          </label>
                        </ng-container>
                        <ng-container *ngSwitchCase="'CURRENCYINPUT'">
                          {{row.value[columnMetaData.fieldKey]? (row.value[columnMetaData.fieldKey] | CurrencyFormatter : (row.value[columnMetaData.currencyCd] || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : '-'}}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          {{row.value[columnMetaData.fieldKey]? (row.value[columnMetaData.fieldKey] | technicalTranslate) : '-'}}
                        </ng-container>
                      </span>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              </td>
            </ng-container>
            <td>
              <a (click)="fetchDataAndEdit(row.value)"> Edit </a> |
              <a *ngIf="metaDataConfig.enableAddRemoveRows" nz-popconfirm nzPopconfirmTitle="Sure to delete?"
                (nzOnConfirm)="removeRow(rowIndex)">Delete</a>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="!refreshGridToggle"></nz-skeleton>
  </form>
</ng-container>

<nz-dropdown-menu #searchFilterMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
      <div class="search-box">
          <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
          <!-- <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
              class="search-button">
              Filter
          </button> -->
          <button nz-button nzSize="small" nzType="primary" (click)="reset()" style="width:100%;">Reset</button>
      </div>
  </div>
</nz-dropdown-menu>

<nz-modal [(nzVisible)]="_dataCaptureModal" [nzTitle]="metaDataConfig.heading" (nzOnCancel)="_dataCaptureModal=false;"
  nzOkText="Add" nzWidth="75%" (nzOnOk)="addDataToGrid(formOutput)">
  <ng-container *nzModalContent>
  <ng-container *ngIf="_dataCaptureModal">
    <ng-container *ngTemplateOutlet="dynamicForm; context: { $implicit: null }">
    </ng-container>
  </ng-container>
  </ng-container>
</nz-modal>


<!-- <nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="search-box">
    <input type="text" nz-input placeholder="Search" [(ngModel)]="searchValue" />
    <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">
      Search
    </button>
    <button nz-button nzSize="small" (click)="reset()">Reset</button>
  </div>
</nz-dropdown-menu> -->

<ng-template let-phrase="phrase" #spellChecker>
  <span style="font-size: xx-small; color: red;">{{(phrase | spellCheck)}}</span>
</ng-template>

<ng-template let-passedData #dynamicForm>
  <app-dynamic-form *ngIf="refreshDynamicComponentToggle" baseDOName="providerDO" [FORMTITLE]="passedData"
    [FORMNAME]="metaDataConfig.controlId" [IO]="dynamicFormPayload" [currentComponentName]="'metaDataConfig.controlId'"
    [ExtractElementFromArray]="true" [(ngModel)]="formOutput" [formMetaData]="metaDataConfig.columns">
  </app-dynamic-form>
</ng-template>
